import { render, staticRenderFns } from "./AddShipmentEstimationComponent.vue?vue&type=template&id=5e03f379"
import script from "./AddShipmentEstimationComponent.vue?vue&type=script&lang=js"
export * from "./AddShipmentEstimationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports